import React, { useMemo } from 'react';
import './style.scss';
import { useTranslation } from 'react-i18next';
import Status, { TStatus } from 'components/Status/Status';
import { getStatusCount } from './helper';

interface StatusSummaryProps<T> {
  data?: T[];
  criticityMap: { [key: string]: TStatus };
  variant: 'calendar' | 'circle';
  legendLocale?: string;
  hasStatusDetail?: boolean;
  statusKey?: keyof T;
  onStatusClick?: (status: string[]) => void;
  activeList?: string[];
}

const StatusSummary = <TData extends { status?: string; name?: string }>({
  data = [],
  criticityMap,
  variant,
  legendLocale = 'monitoring:statusSummary',
  hasStatusDetail,
  statusKey = 'status',
  onStatusClick,
  activeList,
}: StatusSummaryProps<TData>) => {
  const { t } = useTranslation();
  const statusCounts = useMemo(() => getStatusCount(statusKey, data), [statusKey, data]);
  return (
    <div className="status-summary-wrapper">
      {Object.keys(criticityMap).map((status) => (
        <span
          key={status}
          onClick={() => {
            if (activeList && onStatusClick) {
              onStatusClick?.(
                activeList.includes(status)
                  ? activeList.filter((item) => item !== status)
                  : [...activeList, status],
              );
            }
          }}
          className={`status-summary-item ${onStatusClick ? 'filterable' : ''} ${
            activeList?.includes(status) ? 'active' : ''
          }`}
          id={`button-filter-${status}`}
        >
          <Status status={criticityMap[status]} variant={variant} />

          {` ${t(`${legendLocale}.status.${status.toLocaleLowerCase()}`)}: ${
            statusCounts[status] ?? 0
          }`}
          {hasStatusDetail && (
            <span className="status-summary-item-detail">
              {t(`${legendLocale}.statusDetail.${status}`)}
            </span>
          )}
        </span>
      ))}
    </div>
  );
};

export default StatusSummary;
